import React, { useEffect, useRef } from 'react';

import IconTITV from '@components/Images/IconTITV';
import { ANCHOR_TAG } from '@components/pages/AI/DeepResearch/constants';
import useEventTracking from '@hooks/useEventTracking';
import { titv_path, titv_show_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';
import { LeadTypes } from '@utils/enums';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import NewsletterSignupCard from '../NewsletterSignupCard';
import StreamingChannels from '../StreamingChannels';
import { COMING_SOON } from './constants';
import { EpisodeDescriptionProps } from './interfaces';

const EpisodeDescription = ({ event, signupNewsletter }: EpisodeDescriptionProps) => {
  const descriptionRef = useRef<HTMLDivElement>(null);
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.TITVDescription,
  });

  useEffect(() => {
    const descriptionElement = descriptionRef.current;

    function handleClickTracking(this: HTMLElement, event: MouseEvent) {
      const link = (event.target as HTMLElement).closest(ANCHOR_TAG);
      trackEvent(
        click({
          clickTarget: ClickTarget.AnchorLink,
          clickLink: link.href,
          clickText: link.innerText,
        })
      );
    }

    descriptionElement.addEventListener('click', handleClickTracking, {
      capture: true,
      passive: true,
    });

    return () => {
      descriptionElement?.removeEventListener('click', handleClickTracking, {
        capture: true,
        passive: true,
      } as EventListenerOptions);
    };
  }, [trackEvent]);

  return (
    <section className="grid grid-cols-1 gap-y-40 md:grid-cols-3 md:place-items-start md:gap-x-[100px] md:gap-y-0">
      <div className="md:col-span-2" ref={descriptionRef}>
        <h2 className="m-0 font-suisse-intl-mono text-disclosure-lg text-primary-magenta">
          Episode Description
        </h2>

        {event?.description ? AuthoredContentReactToHtmlParser(event.description) : COMING_SOON}
      </div>
      <div className="grid place-items-center gap-y-28 md:col-span-1 md:mt-56 md:place-content-center">
        <IconTITV className="text-primary-magenta" height={127} width={89} aria-label="TITV logo" />
        <p className="m-0 max-w-[187px] font-suisse-intl-mono text-overline-lg font-normal">
          Every weekday at 10am pt / 1pm et
        </p>
        <StreamingChannels />
        {signupNewsletter && (
          <NewsletterSignupCard
            className="w-full"
            leadType={LeadTypes.TITVEpisodeRailNewsletterSignup}
            newsletter={signupNewsletter}
            redirectToOnSuccess={event?.guid ? titv_show_path(event.guid) : titv_path()}
            splitOnTablet
          />
        )}
      </div>
    </section>
  );
};

export default EpisodeDescription;
